<template>
  <div :style="`paddingTop:${barHeight}px`">
    <van-nav-bar :title="this.$i18n.locale == 'zh' ? '用戶協議' : 'Terms of Use'" left-arrow @click-left="closeWeb"></van-nav-bar>
    <div class="page-container" v-if="this.$i18n.locale == 'zh'">
      <p>欢迎你使用GoParty App服务！</p>
      <p>
        为使用GoParty App服务，您应当阅读并遵守《GoParty
        App用户服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款。限制或免除责任条款可能以加粗形式提示您注意。
        除非您已阅读并接受本协议所有条款，否则您无权使用GoParty App服务（以下简称“本服务”）。您对本服务的任何购买、登录、查看等使用行为即视为您已阅读并同意本协议的约束。
      </p>

      <p>如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</p>
      <p>1　接受条款</p>
      <p>
        GoParty App根据以下服务条款为您提供服务。这些条款可由GoParty App随时更新，且毋须另行通知。本协议一旦发生变动，GoParty
        App将在网页上公佈修改内容。修改后的本协议一旦在网页上公佈即有效代替原来的《GoParty App用户服务协议》。此外，当您使用GoParty App特殊服务时，您和GoParty App应遵守GoParty
        App随时公佈的与该服务相关的指引和规则。前述所有的指引和规则，均构成本协议的一部分。 您在使用GoParty
        App提供的各项服务之前，应仔细阅读本使用协议。如您不同意本协议及/或随时对其的修改，请您立即停止使用GoParty App所提供的全部服务；您一旦使用GoParty
        App服务，即视为您已瞭解并完全同意本协议各项内容，包括GoParty App对本协议随时所做的任何修改，并成为GoParty App用户（以下简称“用户”）。
      </p>

      <p>2　服务说明</p>
      <p>
        GoParty App为用户提供录音和播放的服务，使用者可以利用GoParty
        App软体进行录音并上传自己的作品、发佈图片、发表评论。除非本协议另有其它明示规定，增加或强化目前本服务的任何新功能，包括但不限于所推出的新产品，均受到本协议之规范。您瞭解并同意，本服务仅依其当前所呈现的状况提供，对于任何使用者资讯或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，GoParty
        App均不承担任何责任。GoParty App保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利,并无需承担任何责任。
      </p>
      <p>3　您的注册义务</p>
      <p>
        为了能使用本服务全部功能，您同意以下事项：依本服务注册提示请您填写正确的头像、暱称、性别和生日，并确保今后更新的手机门号、暱称、头像等资料的有效性和合法性。若您提供任何违法、不道德或GoParty
        App认为不适合在GoParty App上展示的资料；或者GoParty App有理由怀疑你的资料属于程序或恶意操作，GoParty
        App有权暂停或终止您的帐号，并拒绝您于现在和未来使用本服务之全部或任何部分。 GoParty
        App无须对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料的责任。
      </p>

      <p>4　用户帐号、密码及安全</p>
      <p>
        完成本服务的注册程序并成功注册之后，您可使用相应的第三方帐号，登录到您在GoParty App的帐号（下称“帐号”）。保护您的帐号安全，是您的责任。
        您应对所有使用您的密码及帐号的活动负完全的责任。您同意：
      </p>

      <p>1）您的GoParty App帐号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知GoParty App；</p>
      <p>2）如果您未保管好自己的帐号和密码，因此而产生的任何损失或损害，GoParty App不承担任何责任；</p>
      <p>3）每个用户都要对其帐号中的所有行为和事件负全责。如果您未保管好自己的帐号和密码而对您、GoParty App或任何第三方造成的损害，您将负全部责任。</p>
      <p>5 数据归属</p>
      <p>
        5.1用户数据：是指使用者接受GoParty
        App服务而产生的与使用者相关的数据。用户数据包括用户个人数据如用户真实姓名、身份证号、手机号码、电子邮件或者其它身份资讯，用户的行为数据如用户操作行为形成的数据及各类交易数据等。“用户个人数据”的所有权及其他相关权利属于用户，“用户行为数据”
        的所有权及其他相关权利属于GoParty App，且是GoParty App的商业秘密。
      </p>
      <p>
        1.1. GoParty App的运营数据：是指用户接受本服务而产生的相关资料，包括但不限于用户提交的文字、图片、资料等数据、用户操作行为形成的数据及各类交易数据等。“GoParty
        App的运营数据”的所有权及其他相关权利属于GoParty App，且是GoParty App的商业秘密，依法属于用户享有的相关权利除外。
      </p>
      <p>6 关于通知</p>
      <p>
        6.1 GoParty App可能会以网页公告、网页提示、电子邮箱、手机短信、用户注册的本服务帐户的管理系统内发送站内信等方式中的一种或多种，
        向用户送达关于本服务的各种规则、通知、提示等资讯，该等资讯一经GoParty App採取前述任何一种方式公佈或发送，即视为用户已经接受并同意，对用户产生约束力。
        若用户不接受的，请用户书面通知GoParty App，否则视为用户已经接受、同意。
      </p>
      <p>6.2 若由于用户提供的电子邮箱、手机号码等资讯错误，导致用户未收到相关规则、通知、提示等资讯的，仍然视为用户已经收到相关资讯并受其约束， 一切后果及责任由用户自行承担。</p>
      <p>6.3 若用户有事项需要通知GoParty App的，应当按照本服务对外正式公佈的联繫方式书面通知GoParty App。</p>
      <p>7 GoParty App隐私权政策</p>
      <p>您提供的登记资料及GoParty App保留的有关您的若干其它资料将受到有关隐私的法律和本公司《隐私权声明》之规范。</p>
      <p>8　提供者之责任</p>
      <p>
        根据有关法律法规，GoParty App在此郑重请您注意，任何经由本服务而发佈、上载的文字、资讯、资料、音乐、照片、图形、视讯、资讯或其它资料（以下简称“内容
        ”），无论是公开还是私下传送，均由内容提供者承担责任。GoParty
        App仅为用户提供内容存储空间，无法控制经由本服务传送之内容，因此不保证内容的合法性、正确性、完整性或品质。您已预知使用本服务时，可能会接触到令人不快、不适当或令人厌恶之内容。在任何情况下，GoParty
        App均不为任何内容负责，但GoParty App有权依法停止传输任何前述内容并採取相应行动，包括但不限于暂停用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。
        用户在录音时，如果使用其他的配乐、伴奏、照片资讯配合录制并上载，则用户需要确认对该配乐、伴奏、照片资讯享有相应使用权或获得相应授权，否则GoParty App可删除你上载的内容。
      </p>

      <p>9　用户行为</p>
      <p>9.1用户同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶</p>
      <p>1）发佈或以其它方式传送含有下列内容之一的资讯：危害国家安全，洩露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>损害国家荣誉和利益的；</p>
      <p>煽动民族仇恨、民族歧视、破坏民族团结的；</p>
      <p>破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>散佈谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>散佈淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>侮辱或者诽谤他人，侵害他人合法权利的；</p>
      <p>含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</p>
      <p>含有法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</p>
      <p>含有GoParty App认为不适合在GoParty App展示的内容；</p>
      <p>2）以任何方式危害他人的合法权益；</p>
      <p>3）冒充其他任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；</p>
      <p>
        4）将依据任何法律或合约或法定关係（例如由于雇佣关係和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以发佈、发送电子邮件或以其它方式传送；
      </p>
      <p>5）将侵害他人著作权、专利权、商标权、商业秘密、或其它专属权利（以下简称“专属权利”）之内容加以发佈或以其它方式传送；</p>
      <p>6）将任何广告信函、促销资料、“垃圾邮件”、““滥发信件”、“连锁信件”、“直销”或其它任何形式的劝诱资料加以发佈、发送或以其它方式传送；</p>
      <p>
        7）将设计目的在于干扰、破坏或限制任何电脑及手机软体、硬体或通讯设备功能之病毒（包括但不限于木马程式（trojan
        horses）、蠕虫（worms）、定时炸弹、删除蝇（cancelbots）（以下简称“病毒”）或其它代码、档案和程式之任何资料，加以发佈、发送或以其它方式传送；
      </p>
      <p>8）干扰或破坏本服务或与本服务相连线之服务器和网路，或违反任何关于本服务连线网路之规定、程式、政策或规范；</p>
      <p>9）跟踪、人肉搜索或以其它方式骚扰他人；</p>
      <p>10）故意或非故意地违反任何适用的当地、国家法律，以及任何具有法律效力的规则；</p>
      <p>11）未经合法授权而截获、篡改、收集、储存或删除他人个人资讯、站内邮件或其它资料资料，或将获知的此类资料用于任何非法或不正当目的。</p>
      <p>
        9.2您已认可GoParty App未对用户的使用行为进行全面控制，您使用任何内容时，包括依赖前述内容之正确性、完整性或实用性时，您同意将自行加以判断并承担所有风险，而不依赖于GoParty
        App。但GoParty App依其自行之考虑，有权拒绝和/或删除可经由本服务提供之违反本协议约定的内容或其它违反法律规定的任何内容。
      </p>
      <p>9.3您瞭解并同意，GoParty App依据法律法规的要求，或基于诚信为了以下目的或在合理必要范围内，认定必须将内容加以保存或揭露时，得加以保存或揭露：</p>
      <p>1）遵守法律程序；</p>
      <p>2）执行本协议；</p>
      <p>3）回应任何第三人提出的权利主张；</p>
      <p>4）保护GoParty App、其用户及公众之权利、财产或个人安全；</p>
      <p>5）其它GoParty App认为有必要的情况。</p>
      <p>10　国际使用之特别警告</p>
      <p>您已瞭解国际互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关从台湾或您所在国家或地区输出资讯之传输的所有适用法律法规。</p>
      <p>11　在GoParty App发佈的公开信息</p>
      <p>1）在本协议中，“本服务公开使用区域”系指一般公众可以使用的区域；</p>
      <p>
        2）用户在GoParty App上载或发佈的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益，用户同意授予GoParty
        App所有上述内容在全球范围内的免费、不可撤销的、永久的、可再许可独家使用权许可，据该许可GoParty App将有权以複制、广播、彙编、网路传播及其他不为法律所禁止的方式使用前述内容。
      </p>
      <p>12　赔偿</p>
      <p>
        由于您通过本服务提供、发佈或传送之内容、您与本服务连线、您违反本协议、或您侵害他人任何权利因而衍生或导致任何第三人提出任何索赔或请求，包括但不限于律师费，您同意赔偿GoParty
        App及其子公司、关联企业、高级职员、代理人、品牌共有人或其它合作伙伴及员工，并使其免受损害，并承担由此引发的全部法律责任。
      </p>
      <p>13　关于使用及储存之一般措施</p>
      <p>1）您同意不对本服务任何部分或本服务所使用或获得的内容，进行複制、拷贝、出售、转售或用于任何其它商业目的。</p>
      <p>
        2）您承认并接受关于本服务的使用GoParty
        App有权制订一般措施及限制，包含但不限于本服务将保留所发佈内容或其它发佈内容之最长期间，以及一定期间内您使用本服务之次数上限（及每次使用时间之上限）。通过本服务发佈或传送之任何资讯、通讯资料和其它内容，如被删除或未予储存，您同意GoParty
        App毋须承担任何责任。您也同意，GoParty App有权依其自行之考虑，不论通知与否，随时变更这些一般措施及限制。
      </p>
      <p>14　服务之修改</p>
      <p>
        GoParty App有权于任何时间暂时或永久修改或终止本服务（或其任何部分），且无论通知与否。您同意对于本服务所作的任何修改、暂停或终止，GoParty
        App对您和任何第三人均无需承担任何责任。
      </p>
      <p>15　中止、终止服务</p>
      <p>
        15.1您同意GoParty App基于其自行之考虑，因任何理由，包含但不限于缺乏使用，或GoParty
        App认为您已经违反本协议的约定，终止您的帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，GoParty
        App可立即关闭或删除您的帐号及您帐号中所有相关资讯及文档，及/或禁止继续使用前述文档或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关资讯和文档被关闭或删除，GoParty
        App对您或任何第三人均不承担任何责任。
      </p>
      <p>15.2如用户通知GoParty App不接受本协议或对其的修改，GoParty App有权随时中止或终止向用户提供本服务。</p>
      <p>15.3因不可抗力因素导致用户无法继续使用本服务或GoParty App无法提供本服务的，GoParty App有权随时终止协议。</p>
      <p>15.4本协议约定的其他中止或终止条件发生或实现的，GoParty App有权随时中止或终止向用户提供本服务。</p>
      <p>
        15.5由于用户违反本协议约定，GoParty App依约终止向用户提供本服务后，如用户后续再直接或间接，或以他人名义注册使用本服务的，GoParty App有权直接单方面暂停或终止提供本服务。
      </p>
      <p>
        15.6如本协议或本服务因为任何原因终止的，对于用户的帐号中的全部资料或用户因使用本服务而存储在GoParty App服务器中的资料等任何资讯，GoParty
        App可将该等资讯保留或删除，包括服务终止前用户尚未完成的任何资料。
      </p>
      <p>16　与广告商及其他第三方进行交易</p>
      <p>
        您通过本网站与广告商及其他第三方进行任何形式的通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其它任何相关条款、条件、保证或声明，完全为您与广告商及其他第三方之间之行为。您因前述任何交易或前述广告商及其他第三方而遭受的任何性质的损失或损害，GoParty
        App对此不负任何法律责任。
      </p>
      <p>17　GoParty App之专属权利</p>
      <p>
        您瞭解并同意，本服务及本服务所使用之相关软体（以下简称“软体”）含有受到相关智慧财产权及其它法律保护之专有保密资料。您也瞭解并同意，经由本服务或广告商向您呈现之赞助广告或资讯所包含之内容，亦受到著作权、商标权、服务商标、专利权或其它专属权利之法律保护。未经GoParty
        App或广告商明示授权，您不得修改、出租、出借、出售、散佈本服务或软体之任何部份或全部，或据以制作衍生著作，或使用擅自修改后的软体，包括但不限于为了未经授权而使用本服务之目的。GoParty
        App仅授予您个人、不可移转及非专属之使用权，但您不得（并不得允许任何第三人）複制、修改、创作衍生著作、进行还原工程、反向编译，或以其它方式发现/使用原始码，或出售、转让、再授权或提供软体设定担保，或以其它方式移转软体之任何权利。您同意将通过由GoParty
        App所提供的界面而非任何其它途径使用本服务。
      </p>
      <p>18　担保与保证</p>
      <p>您明确瞭解并同意∶</p>
      <p>1）本协议的任何规定不会免除GoParty App对造成您人身伤害的、或因故意或重大过失造成您财产损失的任何责任；</p>
      <p>
        2）您使用本服务之风险由您个人负担。本服务系依“现状”及“现有”基础提供。GoParty
        App对本服务不提供任何明示或默示的担保或保证，包含但不限于商业适售性、特定目的之适用性及未侵害他人权利等担保或保证；
      </p>
      <p>3）GoParty App不保证以下事项∶</p>
      <p>* 本服务将符合您的要求；</p>
      <p>* 本服务将不受干扰、及时提供、安全可靠或不会出错；</p>
      <p>* 使用本服务取得之结果正确可靠；</p>
      <p>* 您经由本服务购买或取得之任何产品、服务、资讯或其它资讯将符合您的期望；</p>
      <p>4）是否使用本服务下载或取得任何资料应由您自行考虑且自负风险，因任何资料之下载而导致的您电脑/手机系统之任何损坏或资料流程失等后果，由您自行承担；</p>
      <p>5）您自GoParty App或经由本服务取得的任何建议或资讯，无论是书面或口头形式，除非本协议有明确规定，将不构成本协议以外之任何保证。</p>
      <p>19　责任限制</p>
      <p>您明确瞭解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、资料损失或其它无形损失，GoParty App不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：</p>
      <p>1）本服务之使用或无法使用。</p>
      <p>2）为替换从或通过本服务购买或取得之任何商品、资料、资讯、服务，收到的讯息，或缔结之交易而发生的成本。</p>
      <p>3）您的传输或资料遭到未获授权的存取或变造。</p>
      <p>4）任何第三方在本服务中所作之声明或行为。</p>
      <p>5）与本服务相关的其它事宜，但本协议有明确规定的除外。</p>
      <p>6）第三方以任何方式发佈或投递欺诈性资讯，或诱导用户受到经济损失，GoParty App不承担任何责任。</p>
      <p>
        7）用户理解并同意：鉴于网路服务的特殊性，GoParty App有权在无需通知用户的情况下根据GoParty
        App的整体运营情况或相关运营规范、规则等，可以随时变更、中止或终止部分或全部的服务，若由此给用户造成损失的，用户同意放弃追究GoParty App的责任；
      </p>
      <p>
        8）用户理解并同意：为了向用户提供更完善的服务，GoParty
        App有权定期或不定期地对提供本服务的相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停的，若由此给用户造成损失的，用户同意放弃追究GoParty
        App的责任。
      </p>
      <p>
        9）用户理解并同意：GoParty App的服务是按照现有技术和条件所能达到的现状提供的。GoParty App会尽最大努力向用户提供服务，确保服务的连贯性和安全性；但GoParty
        App不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、骇客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、资料丢失以及其他的损失和风险。所以用户也同意：即使GoParty
        App提供的服务存在瑕疵，但上述瑕疵是当时行业技术水准所无法避免的，其将不被视为GoParty App违约，同时，由此给用户造成的资料或资讯丢失等损失的，用户同意放弃追究GoParty
        App的责任。
      </p>
      <p>
        10）用户理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，GoParty
        App将努力在第一时间与相关单位配合，及时进行修复，若由此给用户造成损失的，用户同意放弃追究GoParty App的责任。
      </p>
      <p>
        11）用户理解并同意：若由于对以下情形导致的服务中断或受阻，给用户造成损失的，用户同意放弃追究GoParty
        App的责任：1受到电脑病毒、木马或其他恶意程序、骇客攻击的破坏；2用户或GoParty App的电脑软体、系统、硬体和通信线路出现故障；3用户操作不当；4用户通过非GoParty
        App授权的方式使用本服务；（5）其他GoParty App无法控制或合理预见的情形。
      </p>
      <p>20　GoParty App商标信息</p>
      <p>
        GoParty App以及其它GoParty App注册商标、标志及产品、服务名称，均为GoParty App公司之商标（以下简称“GoParty App标记”）。未经GoParty App事先书面同意，您同意不将GoParty
        App标记以任何方式展示或使用或作其它处理，或表示您有权展示、使用或另行处理GoParty App标记。
      </p>
      <p>21　用户专属权利</p>
      <p>GoParty App尊重他人智慧财产权，呼吁用户也要同样尊重智慧财产权。</p>
      <p>
        GoParty App之服务与资料是基于“现状”提供，而且GoParty
        App明确地表示拒绝对于“服务”、“资料”或“产品”给予任何明示或暗示之保证，包括但不限于，得为商业使用或适合于特定目的之保证。GoParty
        App对于因“服务”、“资料”或“产品”所生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。 如果您对他人的智慧财产权造成了侵害，GoParty
        App将依国家法律法规的规定，或在适当的情形下，将依服务条款或其相关规范性规定，删除特定内容或以至终止您对帐户的使用。 GoParty
        App尊重他人的任何权利（包括智慧财产权），同时也要求我们的用户也尊重他人之权利。GoParty App在适当情况下，得自行决定终止侵害或违反他人权利之使用者的帐号。
        若您认为您的作品的著作权遭到侵害或您的智慧财产权被侵犯，您需及时向GoParty App联繫并提供详实的举证材料。
      </p>

      <p>22 用户行为管理规范</p>
      <p>1、禁止私下买卖GoParty平台货币；</p>
      <p>2、禁止以任何形式发佈带有色情、暴力、恶意侮辱或者诽谤他人的、低级趣味等擦边的内容；</p>
      <p>3、禁止恶意攻击、辱骂、诽谤、骚扰他人，禁止对作品进行侮辱性评论；</p>
      <p>4、禁止在包厢或者其他公众场合发佈不当言论，禁止传播虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他非法信息资料；</p>
      <p>
        5、禁止以任何使用非法辅助软体进行多开小号刷内容、刷平台货币破坏社区平衡、违规发佈内容的行为。包括但不限于单人多开小号，相同作品重複上传、发佈原唱、无本人声音底版、无人声作品等，包厢一对一转出大量平台货币，多开小号刷货币集中转到主号等；
        若有情节严重及屡次违规的用户，官方有权对其账号或设备进行封锁黑名单处理。
        任何用户发现有内容涉嫌侵害他人合法权益或违反本管理规范的，可直接进行举报，请将详细讯息发送至服务信箱：goparty999@gmail.com 。 以上，望用户知悉并自觉遵守GoParty使用规范。
      </p>

      <p>23　其他</p>
      <p>
        1）本协议、指导原则和免责声明构成您与GoParty
        App之全部协定，并规范您对于本服务之使用行为。在您使用相关服务、使用第三方提供的内容或软体时，亦应遵从所适用之附加条款及条件；一经注册或使用本协议下任何服务，即视为用户已阅读并同意接受本协议及上述内容的约束。GoParty
        App有权在必要时单方修改本协议或上述内容，相关内容变更后，如果用户继续使用本服务，即视为用户已接受修改后的相关内容。 如果用户不接受修改后的相关内容，应当停止使用相关服务。
      </p>
      <p>2）本协议及您与GoParty App之关係，均受到法律管辖。</p>
      <p>3）GoParty App未行使或执行本协议任何权利或规定，不构成对前述权利或权利之放弃；</p>
      <p>4）倘本协议之任何规定因与法律抵触而无效，您依然同意应依照法律，努力使该规定所反映之当事人意向具备效力，且本协议其它规定仍应具有法律效力及效果；</p>
      <p>5）本使用协议之标题仅供方便而设，不具任何法律或契约效果；</p>
      <p>6) 只要您登录了GoParty App，就代表您接受任何以上所有协议。</p>
      <p>7）GoParty App对本使用协议享有最终解释权。</p>
      <p>24　版权声明</p>
      <p>若GoParty App网站中之任何内容或网友使用GoParty App服务已侵害您的著作权，请及时提供所需证明。</p>

      <p>GoParty App在接获您的通知并在核实确认后，将儘快移除您所主张涉有侵害著作权之内容。</p>

      <p>
        除经用户同意或于提供服务之目的者外，GoParty App仅得依法令或政府机关之要求，提供用户之识别资料予第三人。您如依本协议提出检举，GoParty
        App仅会依您的请求移除该侵权内容，而不会提供您有关该用户之识别资料。您如欲取得该用户资料，您应向相应之地方政府机关提出申请，GoParty
        App将于前述单位来函要求提供用户资料后即刻配合。
      </p>

      <p>GoParty App团队</p>
    </div>
    <!-- <div class="page-container" v-if="this.$i18n.locale == 'en'" v-html="$t('lang.goParty.user')"></div> -->
    <div class="page-container" v-else v-html="this.$t('lang.goParty.user')"></div>
  </div>
</template>

<script>
import { setTitleIcon } from '@/utils/public.js'

export default {
  data() {
    return {}
  },
  created() {},
  mounted() {
    setTitleIcon()
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.page-container {
  // margin-top: 46px;
  height: calc(100vh);
  padding: 0 15px;
  font-size: 14px;
  line-height: 22px;
  overflow: auto;
  text-align: left;

  .h2 {
    margin: 10px 0;
    font-size: 16px;
  }
}
::v-deep .van-nav-bar__content {
  display: block;
  line-height: 46px;
  background-color: #fff;
}
::v-deep .van-nav-bar .van-icon {
  font-size: 18px;
  color: #111 !important;
}
::v-deep .van-nav-bar__title {
  color: #000;
}
</style>
